import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router";
import "./accountdetail.scss";

const AccountDetail = (props) => {
  const account = props.AccountDetail;
  const [redirect, setRedirect] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  useEffect(() => {
    setRedirect(false);
  }, []);

  return (
    <Fragment>
      <div className="account-detail-desktop">
        <div className="account-image-row mx-auto d-flex">
          <div className="wrapper d-flex align-items-center">
            <div className="image-container d-flex justify-content-center align-items-center">
              {!account.logo_image ? (
                <div className="first-letter">
                  {account.name_en ? account.name_en[0] : ""}
                </div>
              ) : (
                <img
                  src={account.logo_image}
                  width="100%"
                  height="100%"
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
        <div className="detail-row mx-auto d-flex flex-column">
          <div className="detail">
            <div className="label">Email:</div>
            <div className="email">
              {account.vendor_email ? account.vendor_email : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Contact:</div>
            <div className="email">
              {account.vendor_email ? account.vendor_contact : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Store Name:</div>
            <div className="value">
              {account.name_en ? account.name_en : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Store Legal Name:</div>
            <div className="value">
              {account.business_name ? account.business_name : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Default Currency:</div>
            <div className="currency">
              {account.currency ? account.currency : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Default Country:</div>
            <div className="value">
              {account.country_name_en ? account.country_name_en : ""}
            </div>
          </div>
          <div className="detail">
            <div className="label">Store Status</div>
            <div className="value">
              {account.active ? (
                <span className="green">Active</span>
              ) : (
                "InActive"
              )}
            </div>
          </div>
          {account.agreement_policy_url && (
            <div className="detail">
              <a
                href={account.agreement_policy_url}
                style={{ textDecorationLine: "none" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download agreement policy
              </a>
            </div>
          )}
          <div
            className="detail"
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            <button
              className="edit-button"
              type="button"
              onClick={() => setRedirect(true)}
            >
              Edit Details
            </button>
            <button
              className="change-button"
              type="button"
              onClick={() => setChangePassword(true)}
            >
              Change Password
            </button>
          </div>
        </div>
      </div>
      {redirect && <Redirect push to="/vendor/edit-store" />}
      {changePassword && <Redirect push to="/vendor/change-password" />}
    </Fragment>
  );
};

export default AccountDetail;
